import { ChangeDetectionStrategy, Component, ElementRef, inject, input, output, viewChild } from '@angular/core';
import { NgxSkeletonLoaderConfigTheme, NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { Brand, NormilizedBrand } from '@models';
import { NavigationService } from '@core';

@Component({
  selector: 'lib-brands-list',
  templateUrl: './brands-list.component.html',
  styleUrls: ['./brands-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxSkeletonLoaderModule],
})
export class BrandsListComponent {
  readonly brands = input<NormilizedBrand[]>();
  readonly closeAction = output<void>();
  readonly containerRef = viewChild<ElementRef>('container');

  private navigationService = inject(NavigationService);

  readonly skeletonConfig: NgxSkeletonLoaderConfigTheme = {
    height: '24px',
    width: '100%',
    'border-radius': '4px',
    margin: '0',
  };

  onBrandClick(brand: Brand): void {
    this.closeAction.emit();
    this.navigationService.goToBrandStore(brand.id);
  }
}
